/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { CombustionReactor } from "./modelCombustionReactor";

class ControllerCombustionReactor extends ControllerModel {
  constructor() {
    super("ControllerCombustionReactor");
    
    this.setNewNode = (callback) => {
      let _combustionReactor = new CombustionReactor();
      _combustionReactor.decorate(callback);

      this.addNode(_combustionReactor);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _combustionReactor = new CombustionReactor();
      _combustionReactor.copyFrom(node);
      _combustionReactor.decorate(callback);
      this.addNode(_combustionReactor)
    }

    this.getProperties = async (node) => {
      let n = new CombustionReactor();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new CombustionReactor();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerCombustionReactor };
